import { fetchFromApi } from "./fetchFromApi";
export async function leagueAnalysisRequest(body, onProgress) {
  const controller = new AbortController(),
    timeout = setTimeout(() => controller.abort(), 210000);
  try {
    const response = await fetchFromApi("league-analysis", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ...body, stream: true }),
      signal: controller.signal,
    });
    if (!response.ok) throw Error("REQUEST_FAILED");
    if (
      !response.headers.get("content-type")?.includes("application/x-ndjson")
    ) {
      const result = await response.json();
      if (result.success === false)
        throw Error(result.code || "ANALYSIS_FAILED");
      return result;
    }
    const reader = response.body.getReader(),
      decoder = new TextDecoder();
    let buffer = "",
      result;
    while (true) {
      const { value, done } = await reader.read();
      buffer += decoder.decode(value || new Uint8Array(), { stream: !done });
      let index;
      while ((index = buffer.indexOf("\n")) >= 0) {
        const event = JSON.parse(buffer.slice(0, index));
        buffer = buffer.slice(index + 1);
        if (event.type === "progress") onProgress?.(event);
        if (event.type === "result") result = event.result;
      }
      if (done) break;
    }
    if (!result || result.success === false)
      throw Error(result?.code || "ANALYSIS_FAILED");
    return result;
  } finally {
    clearTimeout(timeout);
  }
}
